
  import createMeisterIcons from '../src/createMeisterIcons';

  const MonitorAlt = createMeisterIcons("monitor-alt", [["path",{"fill":"currentColor","d":"M3.75 7A3.26 3.26 0 0 1 7 3.75h10A3.26 3.26 0 0 1 20.25 7v5.25H3.75zm-1.5 6V7A4.76 4.76 0 0 1 7 2.25h10A4.76 4.76 0 0 1 21.75 7v6A4.76 4.76 0 0 1 17 17.75h-4.25v2.5h3.75a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5h3.75v-2.5H7A4.76 4.76 0 0 1 2.25 13m17.912.75A3.266 3.266 0 0 1 17 16.25H7a3.266 3.266 0 0 1-3.162-2.5z","key":"85b3fe5e4397495b7616a86f013b690ac9e737ec","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default MonitorAlt
  